import './LoadingScreen.css';

const LoadingScreen = () => {
  <div className="loading-screen">
    <div className="spinner" />
    <h2>Loading...</h2>
  </div>
};

export default LoadingScreen;